import { render, staticRenderFns } from "./Erp6InventoryDetails.vue?vue&type=template&id=343ed61d&scoped=true&"
import script from "./Erp6InventoryDetails.vue?vue&type=script&lang=js&"
export * from "./Erp6InventoryDetails.vue?vue&type=script&lang=js&"
import style0 from "./Erp6InventoryDetails.vue?vue&type=style&index=0&id=343ed61d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "343ed61d",
  null
  
)

export default component.exports